import React from "react";

import YTPlayer from "./YTPlayer";

interface VideoPlayerProps {
  videoUrl: string;
  type: "youtube" | "normal";
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, type }) => {
  if (type === "youtube") {
    return <YTPlayer videoUrl={videoUrl} />;
  }

  return (
    <div>
      <video src={videoUrl} title="Video player" controls />
    </div>
  );
};

export default VideoPlayer;
